﻿import 'smartmenus';
import { DiagramToggle } from './Diagram.Toggle.js'
import { DiagramScrollLock, DiagramScrollUnlock } from './Diagram.ScrollLock.js'

export async function DiagramSiteNavigation() {
    if (typeof Diagram == "undefined") {
        var Diagram = {};
    }

    Diagram.MainNav = [];
    Diagram.MainNav.$menu = $('.js-main-nav .sm');
    Diagram.MainNav.$narrowMenuToggle = $('.js-narrow-menu-toggle');
    Diagram.MainNav.$searchToggle = $('.js-search-toggle');

    Diagram.MainNav.$menu.smartmenus({
        hideTimeout: 600,
        subMenusMinWidth: '17em',
        subMenusMaxWidth: '17em',
        subMenusSubOffsetX: 8,
        collapsibleBehavior: 'accordion',
        markCurrentItem: true
    });

    Diagram.MainNav.$narrowMenuToggle.on('click', function () {
        DiagramToggle(Diagram.MainNav.$narrowMenuToggle, function (isActive) {
            if (isActive) {
                DiagramScrollLock();
                $('.narrow-menu-close').focus();
            } else {
                DiagramScrollUnlock();
            }
        });
    });

    Diagram.MainNav.$searchToggle.on('click', function () {
        DiagramToggle(Diagram.MainNav.$searchToggle, function (isActive) {
            if (isActive) {
                $('#header-search form').css('visibility', 'visible');
                $('.js-header-search-input').focus();
            } else {
                $('#header-search form').css('visibility', 'hidden');
                $(this).focus();
            }
        });
    });

    //keyboard navigation stuff
    //close narrow menu with escape key
    $(document).on('keydown', function (e) {
        if (e.which == 27) {
                if ($('.js-narrow-menu').hasClass('active')) {
                    Diagram.MainNav.$narrowMenuToggle.first().trigger('click');
                }
        }
    });

    //Narrow menu focus trap
    function narrowFocusTrap(e) {
        if (e.which == 9) {
            $('.site-logo').focus();
            return false
        }
    }

    //windows wider than bravo don't trap focus
    $(document).on('breakpoint-match-bravo', function () {
        $('.utility-nav li:last-child a').off('keydown', narrowFocusTrap);
    });
    
    //windows narrower than bravo trap focus
    $(document).on('breakpoint-unmatch-bravo', function () {
        $('.utility-nav li:last-child a').on('keydown', narrowFocusTrap);
    });
    
}